import React from 'react';
import { Box } from 'grommet';
import SHDImage from '@ui/Image/SHDImage';
import SHDText from '@ui/Text/SHDText';

import { ResponsiveContext } from 'grommet';

const NoGamesToDisplay: React.FC<{ isIScore: boolean }> = ({ isIScore }) => {
  const text = 'There are no upcoming games scheduled';
  const iScoreText = 'Use the iScore app to schedule games';
  const screenSize = React.useContext(ResponsiveContext);

  return (
    <Box
      data-testid="no-games-to-display"
      align="center"
      justify="center"
      margin={{
        horizontal:
          screenSize === 'large' || screenSize === 'xlarge' ? 'auto' : 'medium',
        vertical: 'xxxlarge',
      }}
      width={
        screenSize === 'large' || screenSize === 'xlarge' ? '100%' : 'auto'
      }
    >
      <SHDImage
        alt="schedule_no_games icon"
        className="schedule_no_games"
        isSquare={false}
        src={`/icons/schedule_no_games.svg`}
        width={32}
        margin={{ bottom: 'small' }}
      />
      <Box margin={'xxsmall'}>
        <Box margin={{ top: 'xxsmall' }} align="center">
          <SHDText style="body" color="black-alpha-40">
            {text}
          </SHDText>
        </Box>
        {isIScore && (
          <Box align="center">
            <SHDText color="black-alpha-40">{iScoreText}</SHDText>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default NoGamesToDisplay;
